import React, { forwardRef } from "react";

/**
 * ─── Input ─────────────────────────────────────────────────────────────────
 * Text input primitive (PDR v2.1 §8).
 *
 * Props
 *   error       boolean       — flip red border + red focus ring
 *   iconLeft    ReactNode     — decorative icon in a leading slot
 *   testId
 * All native <input> props pass through (type, placeholder, value, onChange, …).
 *
 * Wrap in `<FormField>` for a labelled + validated + described control.
 */
const Input = forwardRef(function Input(
  { error = false, iconLeft, className = "", testId, ...rest },
  ref,
) {
  const cn = ["ds-input", error && "ds-input--error", className].filter(Boolean).join(" ");
  if (iconLeft) {
    return (
      <span className="ds-input-wrapper">
        <span className="ds-input-icon" aria-hidden>{iconLeft}</span>
        <input ref={ref} className={cn} data-testid={testId} aria-invalid={error || undefined} {...rest} />
      </span>
    );
  }
  return (
    <input ref={ref} className={cn} data-testid={testId} aria-invalid={error || undefined} {...rest} />
  );
});

export default Input;
